<template>
  <div class="table-container">
    <table class="m-flex" aria-label="provider biography">
      <tbody>
        <tr class="nurse-edit" :id="'nurse-edit' + provider.licensenum">
          <td>
            <div :id="'nurseform' + provider.licensenum">
              <label for="nursefname">First Name:</label>
              <input
                type="text"
                id="nursefname"
                placeholder="*Required"
                :value="provider.firstname"
                class="field"
              />
              <label for="nurselname">Last Name:</label>
              <input
                type="text"
                id="nurselname"
                :value="provider.lastname"
                placeholder="*Required"
                class="field"
              />
              <label for="nraccount">Account Number:</label>
              <input
                type="text"
                id="nraccount"
                :value="provider.acountnumber"
                placeholder="*Required"
                class="field"
              />
              <label for="nursetype">Nurse Type:</label>
              <select class="field" id="nursetype" aria-placeholder="*Required">
                <option
                  v-if="provider.licensetype"
                  select="selected"
                  :value="provider.licensetype"
                >
                  Registered Nurse
                </option>
                <option
                  v-else-if="!provider.licensetype"
                  select="selected"
                  value="selected"
                >
                  Select Nurse Type
                </option>
                <!--<option value="RN">Registred Nurse</option>-->
                <option value="LPN">Licensed Practical Nurse</option>
                <option value="CN">Cardiac Nurse</option>
                <option value="CRNA">Certified Registered Nurse Anesthetist</option>
              </select>
              <label for="nraddress">Address:</label>
              <input type="text" id="nraddress" :value="provider.addr1" class="field" />
              <label for="nrcity">City:</label>
              <input type="text" id="nrcity" :value="provider.city" class="field" />
              <label for="nrstate">State:</label>
              <input type="text" id="nrstate" :value="provider.state" class="field" />
              <label for="nrzip">Zip:</label>
              <input type="text" id="nrzip" :value="provider.zip" class="field" />
              <label for="nrlicense">License Number:</label>
              <input
                type="text"
                id="nrlicense"
                :value="provider.licensenum"
                placeholder="*Required"
                class="field"
              />
              <label for="nrdob">Date of Birth:</label>
              <input
                type="date"
                id="nrdob"
                :value="provider.dob"
                placeholder="*Required"
                class="field"
              />
              <label v-if="provider.primaryphone" for="primephone">Primary Phone:</label>
              <input
                v-if="provider.primaryphone"
                type="phone"
                id="primephone"
                :value="provider.primaryphone"
                class="field"
              />
              <label v-if="provider.secondaryphone" for="secphone"
                >Secondary Phone:</label
              >
              <input
                v-if="provider.secondarphone"
                type="phone"
                id="secphone"
                :value="provider.secondaryphone"
                class="field"
              />
              <label v-if="provider.socialnum" for="nrsocial">Social Security:</label>
              <input
                v-if="provider.socialnum"
                type="text"
                id="nrsocial"
                :value="provider.socialnum"
                placeholder="*Required"
                class="field"
              />
              <label v-if="provider.ncsbnid" for="nrnsbid">NBSID Number:</label>
              <input
                v-if="provider.ncsbnid"
                type="text"
                id="nrnsbid"
                :value="provider.ncsbnid"
                class="field"
              />
              <label for="nurseemail">Email:</label>
              <input
                type="email"
                id="nurseemail"
                :value="provider.email"
                placeholder="*Required"
                class="field"
              /><br /><br />
              <div class="btn-sec">
                <input
                  type="button"
                  class="btn btn-primary"
                  value="Updte Nurse"
                  id="updatenursebtn"
                  @click="UpdateNurse($event, provider.licensenum)"
                />
                <input
                  type="button"
                  class="btn btn-secondary"
                  value="Close"
                  id="cancelnursebtn"
                  @click="CancelUpdateNurse($event, provider.licensenum)"
                />
              </div>
            </div>
          </td>
        </tr>
        <tr class="nurse-card">
          <td>
            <div :id="'nursecard' + provider.licensenum">
              <table>
                <tbody>
                  <tr>
                    <td class="m-align" rowspan="60" width="20%">
                      <img
                        src="@/assets/images/avatar-female.jpg"
                        class="provider__avatar"
                      />
                    </td>
                  </tr>
                  <tr v-if="provider.acountnumber">
                    <td class="provider__info capitalize">
                      <font-awesome-icon :icon="['fas', 'arrow-right']" class="icon" />
                      <b>Account Number:</b
                      ><span :id="'accountnum' + provider.licensenum">{{
                        provider.acountnumber
                      }}</span>
                    </td>
                  </tr>
                  <tr v-if="provider.licensetype">
                    <td class="provider__info capitalize">
                      <font-awesome-icon :icon="['fas', 'arrow-right']" class="icon" />
                      <b>License Type:</b
                      ><span :id="'ltype' + provider.licensenum">{{
                        provider.licensetype
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="provider__info capitalize">
                      <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon" />
                      <span v-if="provider.address">
                        <b> Address:</b> {{ provider.address.toLowerCase() }}</span
                      >
                      <span v-else style="color: tomato">Please pull the backend</span>
                      <span v-if="provider.addr2">
                        , {{ provider.addr2.toLowerCase() }}</span
                      >
                      <span v-if="provider.city">
                        , {{ provider.city.toLowerCase() }}</span
                      >
                      <span v-if="provider.state">
                        , {{ provider.state.toUpperCase() }}</span
                      >
                      <span v-if="provider.zip"> , {{ provider.zip }}</span>
                    </td>
                  </tr>
                  <tr v-if="provider.licensenum">
                    <td class="provider__info">
                      <!---<font-awesome-icon icon="phone" :id="'desktopTel'+patient.id" class="icon"/><b>Tel: </b><a href="#call" @click="CallProvider(provider)">{{ provider.tel }}</a>-->
                      <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b
                        >License Number:</b
                      ><a
                        href="#verfiy"
                        :id="'desktopLicense' + provider.licensenum"
                        @click="VerifyNurse(provider.licensenum)"
                        >{{ provider.licensenum }}</a
                      >
                    </td>
                  </tr>
                  <tr v-if="provider.licenseexpdate">
                    <td class="provider__info">
                      <!---<font-awesome-icon icon="phone" :id="'desktopTel'+patient.id" class="icon"/><b>Tel: </b><a href="#call" @click="CallProvider(provider)">{{ provider.tel }}</a>-->
                      <font-awesome-icon
                        :icon="['fas', 'bars-staggered']"
                        :id="'dob' + provider.licensenum"
                      /><b>Expiration Date:</b><span>{{ provider.licenseexpdate }}</span>
                    </td>
                  </tr>
                  <tr v-if="provider.state">
                    <td class="provider__info">
                      <font-awesome-icon :icon="['fas', 'address-book']" class="icon" />
                      <b>jurisdiction:</b>
                      <span :id="'state' + provider.licensenum">{{
                        provider.state
                      }}</span>
                    </td>
                  </tr>
                  <tr v-if="provider.primaryphone">
                    <td class="provider__info">
                      <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b
                        >Cell: </b
                      ><a
                        :id="patient.id"
                        href="#callProvCell"
                        @click="CallProviderCell($event, provider.providerid)"
                        >{{ provider.primaryphone }}</a
                      >
                    </td>
                    <td class="d-option" :id="'d-option' + provider.providerid">
                      <div class="option-container">
                        <div class="x-close">
                          <a
                            href="#closeoption"
                            @click="closeDOption($event)"
                            id="d-itemclose"
                            >X</a
                          >
                        </div>
                        <div
                          v-if="provider.primaryphone"
                          class="option-item"
                          id="option-item1"
                        >
                          <h4>SMS or Call Provider Cell</h4>
                          <span class="slabel">Call:</span>
                          <a href="#callprov" @click="callProvider(provider)">{{
                            provider.primaryphone
                          }}</a
                          ><br /><br />
                          <span class="slabel">Text:</span>
                          <a
                            href="#smsprov"
                            @click="
                              showTextProv(
                                $event,
                                provider.primaryphone,
                                patient.id,
                                provider.providerid
                              )
                            "
                            >{{ provider.primaryphone }}</a
                          ><br />
                        </div>
                      </div>
                    </td>
                    <td class="m-option" :id="'m-option' + provider.providerid">
                      <div class="option-container">
                        <div class="x-close">
                          <a
                            href="#closeoption"
                            @click="closeOption($event)"
                            id="m-itemclose"
                            >X</a
                          >
                        </div>
                        <div
                          v-if="provider.primaryphone"
                          class="option-item"
                          id="option-item1"
                        >
                          <h4>Call Nurse Primary</h4>
                          <a :href="'tel:' + provider.cell">{{
                            provider.primaryphone
                          }}</a>
                        </div>
                        <div v-if="provider.cell" class="option-item" id="option-item1">
                          <h4>Text or Call Provider</h4>
                          <a :href="'tel:' + provider.primaryphone">{{
                            provider.primaryphone
                          }}</a>
                          <a :href="'sms:' + provider.primaryphone">{{
                            provider.primaryphone
                          }}</a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="provider.activestatus">
                    <td class="provider__info">
                      <font-awesome-icon :icon="['fas', 'fax']" class="icon" />
                      <b>Active Status:</b> {{ provider.activestatus }}
                    </td>
                  </tr>
                  <tr v-if="provider.checkstatus">
                    <td class="provider__info">
                      <font-awesome-icon :icon="['fas', 'fax']" class="icon" />
                      <b>Check Status Date:</b> {{ provider.checkstatus }}
                    </td>
                  </tr>
                  <tr v-if="provider.email">
                    <td class="provider__info capitalize">
                      <font-awesome-icon :icon="['fas', 'inbox']" class="icon" />
                      <span
                        ><b>Email:</b
                        ><a
                          href="#patientNurse"
                          @click="showEmailModule($event, provider, provider.providerid)"
                          >{{ provider.email }}</a
                        ></span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import { licenceJurisdiction, enrolmentJurisdiction } from "@/utils/nurseCardJurisdiction";
import { CURR_API, OTHER_API } from "@/constants/apis";
import { lookupFailureMessage } from "@/api/nursysApi";
import { placePhoneCall } from "@/api/smsApi";
import { messagingSender } from "@/utils/messagingSender";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "CurrentProviderBio",
  data() {
    return {
      allProvs: null, // List of providers already saved for patient
      txtMsg: "",
      txtPhone: "", // Fax number of chosen physician
    };
  },
  props: {
    provider: Object,
  },
  beforeMount() {
    this.checkScreensize();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    manager: function () {
      return this.allData.manager;
    },
  },
  methods: {
    checkScreensize() {
      let height = $(window).height;
      let width = $(window).width;
      //alert($(window).width);
      if ($(window).width > 760 && $(window).width <= 1024) {
        alert("Tableet");
      }
    },
    showEmailModule(event, provider, pid) {
      console.log(event.target.id + " " + "ShowEmailModule");
      console.log(event.target);
      console.log(pid);
      $("#emailcanvas" + pid).css("display", "block");
      let subject =
        "You have a message from" +
        " " +
        provider.firstname +
        " " +
        provider.lastname +
        ", PLease login into the Erriff Health Portal to view message.";
      $("#provemailsubject" + pid).val(subject);
      let message =
        "Dr. " +
        provider.firstname +
        ",please login to view your message from the Erriff Health Portal.";
      $("#provid-emailmsg" + pid).val(message);
      console.log($(".emailcanvas").attr("class"));

      $("#emailcanvas" + pid).css("display", "block");
      //now lets bind the providers email address to the email input field
      console.log(provider.email);
      $("#providetomail" + pid).val(provider.email);
      console.log($("#emailcanvas" + pid).attr("id"));
    },
    closeOption(event) {
      $(event.target).closest(".m-option").css("display", "none");
    },
    closeDOption(event) {
      $(event.target).closest(".d-option").css("display", "none");
    },

    async CallProviderCell(event, id) {
      console.log(event.target.id);
      console.log(window.innerWidth);
      console.log("ID" + " " + id);
      if (window.innerWidth < 768) {
        $("#d-option" + id).css("display", "none");
        $("#m-option" + id).css("display", "flex");
      }
      if (window.innerWidth >= 1024) {
        $("#d-option" + id).css("display", "flex");
        $("#m-option" + id).css("display", "none");
      }
    },
    showTextProv(event, prvphone, pid, provid) {
      this.txtPhone = prvphone;
      console.log(this.txtPhone);
      console.log(event.target.id);
      // $("#d-option" + pid).css("display", "flex");
      $("#send-text-modal-" + pid).css("display", "flex");
      $("#modaltext" + pid).val(prvphone);
      $("#d-option" + provid).css("display", "none");
    },
    async VerifyNurse(licensenumber) {
      $("#desktopLicense" + licensenumber).removeAttr("href");
      $("#desktopLicense" + licensenumber).css("background-color", "#000000");
      $("#desktopLicense" + licensenumber).css("color", "#ffffff");
      let licnum = $("#desktopLicense" + licensenumber).html();
      $("#desktopLicense" + licensenumber).html("...verifying");

      //grab info needed to verify
      let content = {
        NursyInfo: {
          API_Meth: "LookupNursesInfo",
          rnlicense: licnum, //$("#desktopLicense"+licensenumber).html(),
          jurisdiction: $("#state" + licensenumber).html(),
          ltype: $("#ltype" + licensenumber).html(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          $("#desktopLicense" + licensenumber).attr("href", "#verify");
          $("#desktopLicense" + licensenumber).css("background-color", "#ffffff");
          $("#desktopLicense" + licensenumber).css("color", "#0d6efd");
          $("#desktopLicense" + licensenumber).html(licensenumber);
          if (res.data != "") {
            if (res.data.status == "Result Not Found") {
              alert("No Result Found for licensnumber" + " " + licensenumber);
            }
            for (var i = 0; i < res.data.length; i++) {
              console.log(i);
              console.log(res.data.length);
              console.log(res.data[i].LicenseType);
              console.log($("#ltype" + licensenumber).html());
              if (res.data[i].LicenseType == $("#ltype" + licensenumber).html()) {
                if (
                  res.data[i].Active != "YES" ||
                  res.data[i].LicenseStatus == "SUSPENSION"
                ) {
                  alert("License Not Active");
                  //lets check to see if they have been reinstated in the NurseLookUpRevision Object
                  if (
                    res.data[i].NurseLookupDisciplines.NurseLookupRevisionReports &&
                    NurseLookupDisciplines.data[i].NurseLookupRevisionReports.length
                  ) {
                    for (
                      var t = 0;
                      t <
                      res.data[i].NurseLookupDisciplines.NurseLookupRevisionReports
                        .length;
                      t++
                    ) {
                      if (
                        res.data[i].NurseLookupDisciplines.NurseLookupRevisionReports[t]
                          .ActionDescription == "LICENSE RESTORED OR REINSTATED, COMPLETE"
                      ) {
                        $(".status-active").attr(
                          "class",
                          "col-sm-12 col-md-12 col-lg-12 status-good"
                        );

                        alert("License Reinstated");
                      }
                    }
                  } else {
                    alert("License Not Active, please take action as needed.");
                    $("#vstatus" + licensenumber).css("display", "block");
                    $("#vstatus2" + licensenumber).css("display", "none");
                  }
                } else if (
                  res.data[i].Active == "YES" ||
                  res.data[i].LicenseStatus == "UNENCUMBERED"
                ) {
                  //its active
                  alert("License Active, no action needed.");
                  $("#vstatus2" + licensenumber).css("display", "block");
                  $("#vstatus" + licensenumber).css("display", "none");
                }
              }
            }
          } else {
            alert("Please verify at a later time.");
          }
        }, (error) => {
          // axios rejects a refused request - keyon's Nursys gate answers a
          // lapsed session with 401 - and with no arm here the link stayed on
          // "...verifying" for good and nothing was said.
          $("#desktopLicense" + licensenumber).attr("href", "#verify");
          $("#desktopLicense" + licensenumber).css("background-color", "#ffffff");
          $("#desktopLicense" + licensenumber).css("color", "#0d6efd");
          $("#desktopLicense" + licensenumber).html(licensenumber);
          alert(lookupFailureMessage(error));
        });
    },
    CancelUpdateNurse(event, licensnum) {
      //close the div section
      event.preventDefault();
      $("#nurseform" + licensnum).css("display", "none");
      $("#nursecard" + licensnum).slideDown("slow");
    },
    async UpdateNurse(event, license) {
      event.preventDefault();
      $("#updatenursebtn").attr("disabled", "disabled");
      let content = {
        ManageNurseList: {
          API_Meth: "Add_Nurse",
          ncsid: $("#nurseform" + license)
            .find("#nrnsbid")
            .val(),
          // The licence's own state; the card's State (the address) only for a
          // licence with none on file (utils/nurseCardJurisdiction).
          jurisdiction: enrolmentJurisdiction(this.provider, $("#nurseform" + license).find("#nrstate").val()),
          subactioncode: "A", //required
          licensnum: $("#nurseform" + license)
            .find("#nrlicense")
            .val(),
          ltype: $("#nurseform" + license)
            .find("#nursetype")
            .val(),
          email: $("#nurseform" + license)
            .find("#nurseemail")
            .val(),
          primephone: $("#nurseform" + license)
            .find("#primephone")
            .val(),
          secondaryphone: $("#nurseform" + license)
            .find("#secphone")
            .val(),
          address1: $("#nurseform" + license)
            .find("#nraddress")
            .val(), //req
          address2: "",
          city: $("#nurseform" + license)
            .find("#nrcity")
            .val(), //req
          state: $("#nurseform" + license)
            .find("#nrstate")
            .val(), //req
          zip: $("#nurseform" + license)
            .find("#nrzip")
            .val(), //req
          lastfourssn: $("#nurseform" + license)
            .find("#nrsocial")
            .val(), //req
          bdayear: $("#nurseform" + license)
            .find("#nrdob")
            .val(), //req
          hospitalpracsetting: "21", //req
          hostpracsettingother: "",
          notficationenabled: "N", //req
          reminderenabled: "N", //req
          locationlist: "",
          recid: "",
          accountnumber: $("#nurseform" + license)
            .find("#nraccount")
            .val(),
          firstname: $("#nurseform" + license)
            .find("nursefname")
            .val(),
          lastname: $("#nurseform" + license)
            .find("#nurselname")
            .val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          $("#updatenursebtn").removeAttr("disabled");
          let jdata = res;
          console.log(jdata);
          if (jdata.data.status == "Nurse Added") {
            alert(
              "Nurse" +
                " " +
                $("#nursefname").val() +
                " " +
                $("#nurselname").val() +
                " Successfully Updated"
            );
            //now close SMS Canvas

            //lets now add them to our internal database

            this.UpdateInternalNurse(license);
          } else if (jdata.data.errors) {
            alert("Issue");
            alert(jdata.errors.ErrorMessage);
          }
        });
    },
    async UpdateInternalNurse(license) {
      let content = {
        ManageNurseList: {
          API_Meth: "InternalUpdateNurse",
          // The person the card shows, and their account type: PATCH /users
          // needs the one, and an aide's number is her HHA certificate, not a
          // state licence (accountBridge.internalUpdateNurse).
          providerid: (this.provider || {}).providerid || (this.provider || {}).unique_ID,
          nurseType: (this.provider || {}).caregivetype || (this.provider || {}).account_type,
          ncsid: $("#nurseform" + license)
            .find("#nrnsbid")
            .val(),
          // The licence's own state, never the card's State field, which is the
          // address (utils/nurseCardJurisdiction).
          jurisdiction: licenceJurisdiction(this.provider),
          subactioncode: "A", //required
          licensnum: $("#nurseform" + license)
            .find("#nrlicense")
            .val(),
          ltype: $("#nurseform" + license)
            .find("#nursetype")
            .val(),
          email: $("#nurseform" + license)
            .find("#nurseemail")
            .val(),
          primearyphone: $("#nurseform" + license)
            .find("#primephone")
            .val(),
          secondaryphone: $("#nurseform" + license)
            .find("#secphone")
            .val(),
          address1: $("#nurseform" + license)
            .find("#nraddress")
            .val(), //req
          address2: "",
          city: $("#nurseform" + license)
            .find("#nrcity")
            .val(), //req
          state: $("#nurseform" + license)
            .find("#nrstate")
            .val(), //req
          zip: $("#nurseform" + license)
            .find("#nrzip")
            .val(), //req
          lastfourssn: $("#nurseform" + license)
            .find("#nrsocial")
            .val(), //req
          bdayear: $("#nurseform" + license)
            .find("#nrdob")
            .val(), //req
          hospitalpracsetting: "21", //req
          hostpracsettingother: "",
          notficationenabled: "Y", //req
          reminderenabled: "Y", //req
          locationlist: "",
          recid: "",
          accountnumber: $("#nurseform" + license)
            .find("#nraccount")
            .val(),
          firstname: $("#nurseform" + license)
            .find("#nursefname")
            .val(),
          lastname: $("#nurseform" + license)
            .find("#nurselname")
            .val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "Updated") {
            alert("Nurse infomration updated successfully!");
            //now close SMS Canvas
          } else {
            alert(res.message);
            console.log("Nurses not added successfully");
          }
        });
    },
    async callProvider(provider) {
      // Connecting only when keyon says Twilio took the call; otherwise its
      // reason (src/api/smsApi.js). keyon connects the call to one of the
      // caller's own numbers on its record - this profile phone when it is one
      // of them - and says what is missing when it has none.
      const result = await placePhoneCall(provider.primaryphone, messagingSender(this.allData).phone);
      alert(result.ok ? "Connecting call..." : result.message);
    },
  },
};
</script>

<style scoped lang="scss">
#nurseform28146329A {
  width: 635px;
  height: auto;
  display: flex;
  flex-direction: column;
}
.status-active {
  display: none;
  background-color: #70a50d;
  color: #ffffff;
  font-size: 17px;
}
.status-nonactive {
  display: none;
  background-color: #f12f4f;
  color: #ffffff;
  font-size: 17px;
}
.nurse-edit {
  display: none;
}
.btn-sec {
  display: flex;
}
#nurseform28146329A input[type="text"] {
  margin-bottom: 10px;
}
#nurseform28146329A input[type="date"] {
  margin-bottom: 10x;
}
#nurseform28146329A input[type="phone"] {
  margin-bottom: 10px;
}
$color-font: darken(#58595b, 10%);
table {
  text-align: left;
  width: 100%;
}

tr {
  font-size: 0.95em;
}

.table-container {
  padding: 1em 2em 1.5em;
  border-bottom: 1px solid lightgray;
}

.provider__avatar {
  width: 100px;
}

.provider__title {
  font-size: 1.5em;
}

.provider__info {
  color: $color-font;
  line-height: 1.8em;
}

.icon {
  margin-right: 0.5em;
}

.capitalize {
  text-transform: capitalize;
}
.nurse-edit {
  /*display:none;*/
}
@media only screen and (min-width: 1024px) {
  .table-container .m-flex {
    display: block;
  }
  .m-align {
    text-align: left;
  }
  .table-container .m-option {
    display: none;
  }
  .x-close {
    height: 21px;
  }
  .option-item h4 {
    font-size: 16px;
    text-align: center;
  }
  .d-option {
    display: flex;
  }
  .m-option {
    display: none;
  }
  .slabel {
    margin-right: 15px;
  }
  .icon .mobileTel {
    display: none;
  }
  .icon .desktopTel {
    display: flex;
  }
}
@media screen and (min-width: 360px) {
  .m-flex {
    display: flex;
    flex-direction: column;
  }
  .m-align {
    text-align: center;
  }
  .m-option {
    display: flex;
    flex-direction: column;
  }
  .d-option {
    display: none;
  }
  .option-container {
    border-color: #0335;
    border-style: solid;
    border-width: 1px;
    padding: 15px 20px;
  }
  .option-item:last-child {
    margin-top: 12px;
  }
  .option-item h4 {
    font-size: 22px;
  }
  .x-close {
    margin-bottom: 0px;
    width: 100%;
    height: 42px;
    display: flex;
    flex-direction: row-reverse;
  }
  .m-itemclose {
    font-size: 20px;
    color: #000000;
  }
  .d-option {
    display: none;
    flex-direction: column;
    position: relative;
    /*left: 580px;
    z-index: 4000000;
    background-color: #fff;
    top: 300px;*/

    left: -180px;
    z-index: 4000000;
    background-color: #fff;
    top: 0px;
    width: 300px;
  }
  .m-option {
    display: none;
  }
  .icon.mobileTel {
    display: flex;
  }
  .icon.desktopTel {
    display: none;
  }
}
</style>
